import { writable, type Writable } from "svelte/store";

type User = {
  accountInfo: AccountInfo | null;
  jwtToken: string | null;
  accountNumber: string | null;
  lastAuthenticated: number | null;
};

type AccountList = {
  accountName: string;
  city: string;
  isSelected: boolean;
  id: string;
  state: string;
  accountNumber: string;
};

type AccountInfo = {
  organizationSegments: string;
  zipCode: string;
  OrgToplinkRelationship: string;
  assortment: string;
  preferredPartFacet: string;
  CMCPageSize: string;
  VerbalAuthAmount: string;
  "SVD_LST_SMRY-SORTBY": string;
  preferredBuyer: string;
  OrgEntitySize: string;
  OrderWorkflowLastUpdateTimeStamp: string;
  preferredPartFlag: string;
  state: string;
  APRequired: string;
  sightPlanEnabled: string;
  OrgWinningRelationship: string;
  userSegments: string;
  tradePosnCntrId: string;
  preferredPartPreference: string;
  OrgEDIUniqID: string;
  PONumberRequired: string;
  companyTypeDescription: string;
  BMSPromotion: string;
  firstName: string;
  SightPlanEnabled: string;
  Assortment: string;
  phone: string;
  AccountLevelOrderThreshold: string;
  mktParameterValueGrid: string;
  userType: string;
  mbrOrdHistOrdViewSeq: string;
  lastName: string;
  customerBPId: string;
  industry: string;
  OrderWorkflowLastUpdatedBy: string;
  OrgEntityPriorSelection: string;
  customerId: string;
  "SVD_LST_DTL-SORTBY": string;
  jwttoken: string;
  email: string;
  GeofencingUUID: string;
  chargeOnAccount: string;
  companyType: string;
  mbrSaveListDetailSeq: string;
  personalizationKey: string;
  ChargeOnAccount: string;
  CMCEnableCommerceAccelerator: string;
  userName: string;
  userId: number;
  userUniqueSessionId: string;
  OrgEDIMapID: string;
  SUMAUser: string;
  accountList: AccountList[];
  mbrSaveListSeq: string;
  mbrOrdHistDetailSeq: string;
};

const User: Writable<User> = writable({
  accountInfo: null,
  jwtToken: null,
  accountNumber: null,
  lastAuthenticated: null,
});

const UserPromise: Writable<Promise<User | undefined>> = writable();

export { User as default, UserPromise };
